import { capitalize, listNl } from '../core/format/text'
import { isOpen } from '../core/rules/schedule'
import type { Founder, OpeningDay, PressLogo, Salon } from '../core/types/site'

/** Het logo — één bron voor site, beheer en merkstijl. */
export const LOGO =
  'https://cdn.magicpatterns.com/uploads/aK4zN9dM4nFr9UEPSqRepA/beautybewust-logo-menu-300x140.jpg'

export const founder: Founder = {
  name: 'Sarah Piening',
  firstName: 'Sarah',
  role: 'Huidspecialist & oprichter',
  portrait:
    'https://cdn.magicpatterns.com/uploads/8fhxQztuHxKb8PGxm2Fvw9/Sarah-Piening-mobiel.jpg',
  atWork:
    'https://cdn.magicpatterns.com/uploads/azzLeCawxKA2qtysfHbXME/18113845093809152-s-80-400.jpg',
  withProducts:
    'https://cdn.magicpatterns.com/uploads/m4i5JC6c4qT7zLae7QU6Hb/18173167903394575-s-80-400.jpg',
  portraitPalm:
    'https://cdn.magicpatterns.com/uploads/gixDmFYTUQBuLWRvyJprdG/18324627148173462-s-80-400.jpg',
}

export const salon: Salon = {
  name: 'Beauty Bewust',
  city: 'Amsterdam-Oost',
  street: 'Arent Janszoon Ernststraat 171',
  postalCode: '1083 GT',
  locality: 'Amsterdam',
  address: 'Arent Janszoon Ernststraat 171, 1083 GT Amsterdam',
  routeUrl:
    'https://www.google.com/maps/dir/?api=1&destination=Arent+Janszoon+Ernststraat+171+1083+GT+Amsterdam',
  email: 'sarah@beautybewust.nl',
  emailAlt: 'saarvoorbeauty@gmail.com',
  phone: '06 – 36 111 580',
  phoneIntl: '+31636111580',
  whatsapp: 'https://wa.me/31636111580',
  instagram: 'https://www.instagram.com/beautybewust/',
  kvk: '57156077',
  // TODO vóór livegang: het echte btw-id invullen (Instellingen › Salon & contact). Leeg = wordt niet getoond.
  vatId: '',
  iban: '',
  invoicePrefix: '',
  englishNote: 'English information or appointments? Mail sarah@beautybewust.nl',
  // TODO vóór livegang: deze drie regels laten controleren door Sarah (Instellingen › Salon & contact).
  // Toegankelijkheid staat bewust leeg: alleen invullen wat zeker klopt, anders verdwijnt de regel.
  transit: 'Tram en bus stoppen op een paar minuten lopen. Plan je route voor de snelste verbinding.',
  parking: 'Betaald parkeren in de straat. Kom je met de auto, reken dan een paar minuten extra.',
  entrance: 'Bel aan bij Beauty Bewust. Ik doe zelf open, op de tijd van je afspraak.',
  accessibility: '',
}

/**
 * Salondagen — alleen op afspraak. Volgorde = volgorde op de site. `staffId` = wie er werkt
 * (leeg = Sarah). Dinsdag en vrijdag: de voorbeeldcollega (data/staff.ts, vóór livegang nalopen).
 */
export const openingHours: OpeningDay[] = [
  { day: 'Maandag', weekday: 1, open: '13:00', close: '20:00' },
  { day: 'Dinsdag', weekday: 2, open: '13:00', close: '19:00', staffId: 'mila' },
  { day: 'Woensdag', weekday: 3 },
  { day: 'Donderdag', weekday: 4, open: '09:00', close: '17:00' },
  { day: 'Vrijdag', weekday: 5, open: '10:00', close: '17:00', staffId: 'mila' },
  { day: 'Zaterdag', weekday: 6 },
  { day: 'Zondag', weekday: 0, open: '09:00', close: '17:00' },
]


/** "13:00 – 20:00" of "Gesloten". */
export const hoursLabel = (d: OpeningDay) => (isOpen(d) ? `${d.open} – ${d.close}` : 'Gesloten')

/** De dagen dat de praktijk dicht is, afgeleid van `openingHours`. */
export const closedDaysLabel = (hours: readonly OpeningDay[] = openingHours) => {
  const closed = hours.filter((h) => !isOpen(h)).map((h) => h.day.toLowerCase())
  return closed.length ? `${capitalize(listNl(closed))} gesloten` : ''
}

export const pressLogos: PressLogo[] = [
  {
    name: "Women's Health",
    image: 'https://cdn.magicpatterns.com/uploads/1vdgdNRTrWZxij2QbhpfZh/Womans-Health.jpg',
    size: 'sm',
  },
  {
    name: 'Go With The Glow',
    image: 'https://cdn.magicpatterns.com/uploads/7i7wY9LogHd22uG3So76F2/Go-with-the-flow.jpg',
    size: 'lg',
  },
]

export const pressMentions = ['BeautyJournaal', 'LINDA.', 'Marie Claire']
